<mat-card id="card" fxLayout="column" class="mainContentBody">
    <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
        <h2>Gestione Device</h2>
        <div fxLayout="column" class="responsive-mat-form">
          <mat-form-field>
            <input matInput [(ngModel)]="parameters.filter" placeholder="Filter"/>
          </mat-form-field>
        </div>
        <mat-card-actions>
          <button mat-raised-button id="search-button" (click)="list()" name="Search" color="primary">Search</button>
          <button mat-raised-button id="new-button" [routerLink]="['/device/detail/0']">New</button>
        </mat-card-actions>
        <br/>
        <div *ngIf="parameters.showList" fxLayout="column">
          <table mat-table fxFlex matTableExporter #exporter="matTableExporter" [hiddenColumns]="hiddenColumns()"
            matSort (matSortChange)="setSort($event)" matSortDisableClear 
            [dataSource]="parameters.dataSource">
        
            <!-- Id Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.id }} </td>
            </ng-container>
            
            <!-- codiceCespite Column -->
            <ng-container matColumnDef="codiceCespite">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Codice cespite </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.codiceCespite }} </td>
            </ng-container>
            
            <!-- mac Column -->
            <ng-container matColumnDef="mac">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Mac </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.mac }} </td>
            </ng-container>
            
            <!-- serie Column -->
            <ng-container matColumnDef="serie">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Serie </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.serie }} </td>
            </ng-container>
            
            <!-- fattura Column -->
            <ng-container matColumnDef="fattura">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Fattura </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.fattura }} </td>
            </ng-container>
            
            <!-- dataConsegna Column -->
            <ng-container matColumnDef="dataConsegna">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Data di consegna </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.dataConsegna | date: 'dd/MM/yyyy'}} </td>
            </ng-container>
            
            <!-- dataRiconsegna Column -->
            <ng-container matColumnDef="dataRiconsegna">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Data di riconsegna </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.dataRiconsegna | date: 'dd/MM/yyyy'}} </td>
            </ng-container>
            
            <!-- formattato Column -->
            <ng-container matColumnDef="formattato">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > formattato </th>
              <td mat-cell *matCellDef="let dispositivo"> {{ dispositivo.formattato }} </td>
            </ng-container>
            
            <!-- tipoId Column -->
            <ng-container matColumnDef="tipoId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > tipoId </th>
                <td mat-cell *matCellDef="let element">
                  {{ getDescrizioneTipo(element.tipoId) }} 
                </td>
            </ng-container>
            
            <!-- collaboratore Column -->
            <ng-container matColumnDef="collaboratore">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > collaboratoreId </th>
                <td mat-cell *matCellDef="let element">
                  {{ getNomeCollaboratore(element.collaboratoreId) }} 
                </td>
            </ng-container>

            <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let dispositivo">
                  <button mat-mini-fab color="primary" [routerLink]="['/device/detail/', dispositivo.id]"><mat-icon>search</mat-icon></button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-card-actions>
                <button mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'devices'})">Excel</button>
                <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('csv', {fileName:'types'})">Csv</button>
                <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('json', {fileName:'types'})">Json</button>
            </mat-card-actions>
            <mat-paginator [pageSize]="parameters.pageSize" [pageIndex]="parameters.pageNumber" [length]="parameters.length" [pageSizeOptions]="[10,50,100]" (page)="setPaginator($event)"></mat-paginator>
          </div>
      </div>
    </mat-card-content>
  </mat-card>